import { createRectPath } from "../../../common/shape/rect";

import { getTheme } from "../../../graphic/theme";

import { RICHTEXT_NUMBER_TYPE } from "../../../graphic/constants";

import { fillVisible } from "./utils";

import { BaseRender } from "./base-render";

import { defaultTextBackgroundRenderContribution } from "./contributions/text-contribution-render";

export class DefaultCanvasRichTextRender extends BaseRender {
    constructor() {
        super(), this.numberType = RICHTEXT_NUMBER_TYPE, this.builtinContributions = [ defaultTextBackgroundRenderContribution ], 
        this.init();
    }
    drawShape(richtext, context, x, y, drawContext) {
        const richtextAttribute = getTheme(richtext).richtext, {strokeOpacity: strokeOpacity = richtextAttribute.strokeOpacity, opacity: opacity = richtextAttribute.opacity, fillOpacity: fillOpacity = richtextAttribute.fillOpacity, visible: visible = richtextAttribute.visible} = richtext.attribute;
        if (!richtext.valid || !visible) return;
        const fVisible = fillVisible(opacity, fillOpacity, !0), sVisible = fillVisible(opacity, strokeOpacity, !0);
        if (!fVisible) return;
        context.setShadowBlendStyle && context.setShadowBlendStyle(richtext, richtext.attribute, richtextAttribute), 
        context.translate(x, y), this.beforeRenderStep(richtext, context, x, y, fVisible, sVisible, fVisible, sVisible, richtextAttribute, drawContext);
        richtext.getFrameCache().draw(context, this.drawIcon), this.afterRenderStep(richtext, context, x, y, fVisible, sVisible, fVisible, sVisible, richtextAttribute, drawContext);
    }
    drawIcon(icon, context, x, y, baseline) {
        var _a;
        const richtextIconAttribute = getTheme(icon).richtextIcon, {width: width = richtextIconAttribute.width, height: height = richtextIconAttribute.height, opacity: opacity = richtextIconAttribute.opacity, image: url, backgroundFill: backgroundFill = richtextIconAttribute.backgroundFill, backgroundFillOpacity: backgroundFillOpacity = richtextIconAttribute.backgroundFillOpacity, backgroundStroke: backgroundStroke = richtextIconAttribute.backgroundStroke, backgroundStrokeOpacity: backgroundStrokeOpacity = richtextIconAttribute.backgroundStrokeOpacity, backgroundRadius: backgroundRadius = richtextIconAttribute.backgroundRadius, margin: margin} = icon.attribute, {backgroundWidth: backgroundWidth = width, backgroundHeight: backgroundHeight = height} = icon.attribute;
        if (margin && (x += icon._marginArray[3], y += icon._marginArray[0]), icon._hovered) {
            const expandX = (backgroundWidth - width) / 2, expandY = (backgroundHeight - height) / 2;
            0 === backgroundRadius ? (context.beginPath(), context.rect(x - expandX, y - expandY, backgroundWidth, backgroundHeight)) : (context.beginPath(), 
            createRectPath(context, x - expandX, y - expandY, backgroundWidth, backgroundHeight, backgroundRadius, !0)), 
            backgroundFill && (context.globalAlpha = backgroundFillOpacity, context.fillStyle = backgroundFill, 
            context.fill()), backgroundStroke && (context.globalAlpha = backgroundStrokeOpacity, 
            context.strokeStyle = backgroundStroke, context.stroke());
        }
        const res = url && (null === (_a = null == icon ? void 0 : icon.resources) || void 0 === _a ? void 0 : _a.get(url));
        res && "success" === res.state && (context.globalAlpha = opacity, context.drawImage(res.data, x, y, width, height));
    }
    draw(richtext, renderService, drawContext) {
        const richtextAttribute = getTheme(richtext).richtext;
        this._draw(richtext, richtextAttribute, !1, drawContext);
    }
}
//# sourceMappingURL=richtext-render.js.map
